export const HANDOFF_PAYLOAD_HASH_KEY = 'payload';

export const HANDOFF_PAYLOAD_STORAGE_KEY = 'glomo.investorPortal.handoffPayload';

// The blob is the credential and travels as a header, matching the
// X-Payment-Session-Auth-Token pattern on our other public surfaces.
export const INVESTOR_PORTAL_AUTH_HEADER = 'X-Investor-Portal-Auth-Token';

export const INVESTOR_ENTRY_QUERY_KEY = ['investor-portal', 'resolve'] as const;
